// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"_3XX1z","logo":"_17AbP"};